import { useCallback } from 'react'
import { useBetSliderStore } from '@stores/betSliderStore'
import { useConfigurationStore } from '@stores/configurationStore'

/**
 * Returns a predicate that decides whether cents should be hidden for a given
 * amount. The amount varies per call site (bet value, autoplay cost, slider
 * value, ...), so the hook exposes the rule as a function rather than a boolean.
 */
const useShouldHideCents = () => {
    const currencyHideCents = useConfigurationStore((s) => s.currencyHideCents)
    const centsVisibilityMoneyLimit = useConfigurationStore((s) => s.centsVisibilityMoneyLimit)
    const shouldShowCentsOnMoneyLimit = useConfigurationStore((s) => s.shouldShowCentsOnMoneyLimit)
    const hideCentsWhenMultipleOf = useBetSliderStore((s) => s.hideCentsWhenMultipleOf)

    return useCallback(
        (amount: number) =>
            currencyHideCents ||
            (amount > centsVisibilityMoneyLimit &&
                !shouldShowCentsOnMoneyLimit &&
                Boolean(hideCentsWhenMultipleOf && amount % hideCentsWhenMultipleOf === 0)),
        [currencyHideCents, centsVisibilityMoneyLimit, shouldShowCentsOnMoneyLimit, hideCentsWhenMultipleOf]
    )
}

export default useShouldHideCents
